var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Renderer2 } from '@angular/core';
import { DrawerModes, ListingCategory, SearchType } from '../../classes/enums';
import { ActivatedRoute, Router } from '@angular/router';
import { CommunicationService } from '../../services/communication.service';
import { HasSubscriptions } from '../has-subscriptions';
import { StyleService } from '../../services/style/style.service';
var DrawerComponent = /** @class */ (function (_super) {
    __extends(DrawerComponent, _super);
    function DrawerComponent(_renderer, _router, activatedRoute, communicationService, styleService) {
        var _this = _super.call(this) || this;
        _this._renderer = _renderer;
        _this._router = _router;
        _this.activatedRoute = activatedRoute;
        _this.communicationService = communicationService;
        _this.styleService = styleService;
        _this.searchType = SearchType.OFFICE;
        _this.drawerMode = DrawerModes.CLOSED;
        // enums:
        _this.DrawerModes = DrawerModes;
        _this.ListingCategory = ListingCategory;
        return _this;
    }
    DrawerComponent.prototype.ngOnInit = function () {
    };
    DrawerComponent.prototype.openDrawer = function (mode) {
        // we need to pass the searchType to the filters component, this is where we get the value from the activatedRoute
        // not sure why the firstChild is required, but I wasn't able to get the values without it
        if (this.activatedRoute.snapshot.firstChild && this.activatedRoute.snapshot.firstChild.params.type) {
            this.searchType = this.activatedRoute.snapshot.firstChild.params.type.toUpperCase();
        }
        this.drawerMode = mode;
        this.styleService.addClass(this._renderer, 'html', 'no-scroll');
    };
    DrawerComponent.prototype.closeDrawer = function (navigateHome) {
        if (navigateHome === void 0) { navigateHome = false; }
        this.drawerMode = DrawerModes.CLOSED;
        // TODO: is this the right way to do it
        this.styleService.removeClass(this._renderer, 'html', 'no-scroll');
        this.communicationService.navigation.showSearch.next(false);
        if (navigateHome && !(this._router.url.includes('-lst') || this._router.url.includes('-prty'))) {
            this._router.navigate(['/find-real-estate']);
        }
    };
    return DrawerComponent;
}(HasSubscriptions));
export { DrawerComponent };
